import Echo from "laravel-echo";
import { NotifyManager } from "notify-component";
import {Subscription, timer} from "rxjs";
import io from "socket.io-client";

const CHAT_NOTIFY_TITLE = "Чат";
const CHAT_CONNECTION_FAILED_MESSAGE =
    "Не удалось подключиться к сервису чатов. Проверьте сеть или обновите страницу позже.";

/** Показали ли уже уведомление о сбое до следующего успешного connect (без спама при ретраях). */
let chatServiceFailureNotificationShown = false;
let reconnectSubscription: Subscription | null = null;

export function clearChatId(phone: string | null | undefined): string {
    return typeof phone === "string" ? phone.replace(/[^\w\s!?]/g, "") : "";
}

function showChatConnectionFailedNotificationOnce(): void {
    if (chatServiceFailureNotificationShown) return;
    chatServiceFailureNotificationShown = true;
    NotifyManager.error(CHAT_NOTIFY_TITLE, CHAT_CONNECTION_FAILED_MESSAGE);
}

function getEffectiveChatEnv(): string {
    const env = process.env.REACT_APP_ENV;
    const host = (process.env.REACT_APP_SOCKET_HOST ?? "").toLowerCase();
    if (env === "testing" && host && !host.includes("testing") && !host.includes("demo")) {
        return "production";
    }
    return env || "production";
}

function disconnectExistingEcho(): void {
    const existing = window.Echo;
    if (!existing) {
        return;
    }
    try {
        existing.disconnect();
    } catch {
        /* already torn down */
    }
    window.Echo = undefined;
}

export function connectWebsocket(userId: number | string): void {
    if (typeof window === "undefined") {
        return;
    }

    const environment = getEffectiveChatEnv();
    if (!environment) {
        return;
    }

    const socketHost = process.env.REACT_APP_SOCKET_HOST;
    if (!socketHost) {
        return;
    }

    const apiToken = localStorage.getItem("api_token");
    if (!apiToken) {
        return;
    }

    const headers: Record<string, string> = {
        Authorization: apiToken,
        UserId: `${environment}-${userId}`,
    };

    const socketTls = process.env.REACT_APP_SOCKET_TLS ?? "wss";
    const socketPort = process.env.REACT_APP_SOCKET_PORT ?? "";
    const apiBaseUrl = (process.env.REACT_APP_API_URL ?? "").replace(/\/$/, "");

    if (!apiBaseUrl) {
        return;
    }

    disconnectExistingEcho();

    window.Echo = new Echo({
        broadcaster: "socket.io",
        client: io,
        host: `${socketTls}://${socketHost}:${socketPort}`,
        auth: { headers },
        authEndpoint: `${apiBaseUrl}/broadcasting/auth`,
        enabledTransports: ["ws", "wss"],
        transports: ["websocket", "polling"],
    });

    const socket = window.Echo?.connector?.socket;
    if (socket == null) {
        return;
    }

    socket.on("disconnect", () => {
        reconnectSubscription?.unsubscribe();
        reconnectSubscription = timer(5000, 5000).subscribe(() => {
            socket.connect();
        });
    });

    socket.on("connect", () => {
        reconnectSubscription?.unsubscribe();
        reconnectSubscription = null;
        chatServiceFailureNotificationShown = false;
    });

    socket.on("connect_error", () => {
        showChatConnectionFailedNotificationOnce();
    });
}
